"use client"

import type React from "react"

export type QRCodeType = "url" | "text" | "email" | "phone" | "sms" | "whatsapp" | "wifi" | "vcard" | "location"

interface QRTypeSelectorProps {
  selectedType: QRCodeType
  onTypeChange: (type: QRCodeType) => void
}

const QRTypeSelector: React.FC<QRTypeSelectorProps> = ({ selectedType, onTypeChange }) => {
  const qrTypes = [
    { id: "url", label: "URL", icon: "🔗" },
    { id: "text", label: "Text", icon: "📝" },
    { id: "email", label: "Email", icon: "📧" },
    { id: "phone", label: "Phone", icon: "📞" },
    { id: "sms", label: "SMS", icon: "💬" },
    { id: "whatsapp", label: "WhatsApp", icon: "📱" },
    { id: "wifi", label: "WiFi", icon: "📶" },
    { id: "vcard", label: "Contact", icon: "👤" },
    { id: "location", label: "Location", icon: "📍" },
  ]

  return (
    <div className="qr-type-selector">
      <h3>QR Code Type</h3>
      <div className="type-buttons">
        {qrTypes.map((type) => (
          <button
            key={type.id}
            className={`type-button ${selectedType === type.id ? "active" : ""}`}
            onClick={() => onTypeChange(type.id as QRCodeType)}
            aria-label={`Select ${type.label} QR code type`}
          >
            <span className="type-icon">{type.icon}</span>
            <span className="type-label">{type.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default QRTypeSelector
